export default __webpack_public_path__ + "static/media/CNP-DirectIntergration.0a6c2033.yaml";